import { render, staticRenderFns } from "./GuildRoles.vue?vue&type=template&id=0abf65ca&scoped=true&"
import script from "./GuildRoles.vue?vue&type=script&lang=js&"
export * from "./GuildRoles.vue?vue&type=script&lang=js&"
import style0 from "./GuildRoles.vue?vue&type=style&index=0&id=0abf65ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abf65ca",
  null
  
)

export default component.exports